<template>
  <o-dialog
    ref="dialog"
    :title="$t('purchaseOrder.markAsSent')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'success', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { PurchaseOrder } from '~/_api/models/purchaseOrder'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const purchaseOrder = ref<PurchaseOrder | null>(null)

const info = computed(() => {
  return $i18n.t('components.purchaseOrder.actions.send.info')
})

const open = (po: PurchaseOrder) => {
  purchaseOrder.value = po
  dialog.value.open()
}

const confirm = async () => {
  if (!purchaseOrder.value) return

  emit('update:loading', true)

  try {
    const response = await $api.purchaseOrder.send(purchaseOrder.value)
    emit('update:loading', false)

    if (response.data) {
      $notification.toast({
        title: $i18n.t('components.purchaseOrder.actions.send.success'),
        text: $i18n.t('purchaseOrder.title2', { label: purchaseOrder.value.purchaseOrderNumber }),
      })

      emit('success')

      return true
    }
  } catch (e: any) {
    $notification.error({ errors: e?.errors })
    emit('error')
  }
}

defineExpose({
  open,
})
</script>
